import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchCategoriesApi,
  addCategoryApi,
  updateCategoryApi,
  deleteCategoryApi,
} from "../services/ExpenseCategoryService";

// Fetch all categories
export const fetchCategories = createAsyncThunk(
  "categories/fetchCategories",
  async ({ searchText = "" }, { rejectWithValue }) => {
    try {
      const response = await fetchCategoriesApi(searchText);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Add new category
export const addCategory = createAsyncThunk(
  "categories/addCategory",
  async (categoryData, { rejectWithValue }) => {
    try {
      const response = await addCategoryApi(categoryData);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Update category
export const updateCategory = createAsyncThunk(
  "categories/updateCategory",
  async (categoryData, { rejectWithValue }) => {
    try {
      const response = await updateCategoryApi(categoryData);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Delete category
export const deleteCategory = createAsyncThunk(
  "categories/deleteCategory",
  async (categoryId, { rejectWithValue }) => {
    try {
      const response = await deleteCategoryApi(categoryId);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

const categorySlice = createSlice({
  name: "categories",
  initialState: {
    categories: [],
    status: "idle",
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Categories
      .addCase(fetchCategories.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = null;
        state.categories = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Add Category
      .addCase(addCategory.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addCategory.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = null;
        state.categories.push(action.payload);
      })
      .addCase(addCategory.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to create category.";
      })
      // Update Category
      .addCase(updateCategory.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateCategory.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = null;
        const index = state.categories.findIndex(
          (category) => category.category_id === action.payload.category_id,
        );
        if (index !== -1) {
          state.categories[index] = action.payload;
        }
      })
      .addCase(updateCategory.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to update category.";
      })
      // Delete Category
      .addCase(deleteCategory.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(deleteCategory.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = null;
        state.categories = state.categories.filter(
          (category) => category.category_id !== action.payload,
        );
      })
      .addCase(deleteCategory.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to delete category.";
      });
  },
});

export const { clearError } = categorySlice.actions;
export default categorySlice.reducer;
